'use client';
import React from 'react';

import YouTubePlayer from '../../../components/video/YouTubePlayer';
import useModal from '../../../hooks/useModal';
import { useUserContext } from '../../../context/UserContext';
import { useVideoPlayer } from '../../../context/VideoPlayerProvider';
import { OnProgressProps } from 'react-player/base';
import dynamic from 'next/dynamic';
import { MAX_LOGGED_OUT_WATCH_SECONDS } from '../../../constants/lockout';
const LearnLockoutModal = dynamic(
  () => import('../../../components/learn/LearnLockoutModal'),
  { ssr: false },
);

type Props = {
  url: string;
  poster: string;
  watchSeconds?: number;
};

/**
 * LockoutWrapper component.
 */
const LockoutWrapper = ({ url, poster, watchSeconds }: Props) => {
  const lockoutModal = useModal();
  const { user } = useUserContext();
  const { handlePause } = useVideoPlayer();

  const lockoutTime = watchSeconds || MAX_LOGGED_OUT_WATCH_SECONDS;

  const handleProgress = (state: OnProgressProps) => {
    if (!user) {
      if (state.playedSeconds > lockoutTime) {
        handlePause();
        lockoutModal.show();
      }
    }
  };

  return (
    <>
      <LearnLockoutModal modalProps={lockoutModal} />

      <YouTubePlayer url={url} poster={poster} onProgress={handleProgress} />
    </>
  );
};

export default LockoutWrapper;
